import { render, staticRenderFns } from "./LinkModal.vue?vue&type=template&id=32d40fe4&scoped=true&"
import script from "./LinkModal.vue?vue&type=script&lang=js&"
export * from "./LinkModal.vue?vue&type=script&lang=js&"
import style0 from "./LinkModal.vue?vue&type=style&index=0&id=32d40fe4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d40fe4",
  null
  
)

export default component.exports